(function () {
  'use strict';

  angular.module('app').component('transportationCostDetail', transportationCostDetail());

  function transportationCostDetail() {
    return {
      bindings: {
        transportationCosts: '=',
        transportation: '<',
        paxRanges: '<',
        seasonSelected: '<',
        priceListSelected: '<',
        provider: '<',
        onTransportationCostsSaved: '&',
        onTransportationCostsCanceled: '&',
        getAssociatedProvidersOnSave: '<',
      },
      controller: TransportationCostDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/transportation-costs/transportation-cost-detail/transportation-cost-detail.component.html',
    };
  }

  TransportationCostDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'TransportationCostService',

    // Angular downgraded service
    'paxRangeService',
  ];

  function TransportationCostDetailComponent(
    config,
    UtilService,
    TransportationCostService,

    // Angular downgraded service
    paxRangeService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    vm.selectPaxRange = selectPaxRange;

    vm.saveTransportationCosts = saveTransportationCosts;
    vm.cancel = cancel;

    vm.$onInit = function () {
      var paxRangeToSelect = '';

      // ng-dropdown settings
      vm.paxRangesSelected = [];
      vm.paxRangesSettings = {
        displayProp: 'name',
        showCheckAll: false,
        showUncheckAll: false,
        smartButtonMaxItems: 5,
        dynamicTitle: false,
        styleActive: true,
      };

      vm.paxRangesEvents = {
        onItemSelect: function (item) {
          selectPaxRange(item);
        },
        onItemDeselect: function (item) {
          if (vm.paxRangesSelected.length > 0) {
            paxRangeToSelect = vm.paxRangesSelected[0];
          } else {
            // Select at least one pax range
            paxRangeToSelect = item;
            vm.paxRangesSelected.push(item);
          }

          selectPaxRange(paxRangeToSelect);
        },
      };

      vm.translationText = {
        buttonDefaultText: 'Pax ranges',
      };

      if (vm.transportationCosts.length > 0) {
        // Edit and exists costs
        setSelectedPaxRanges();
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRangesSelected);

        setItemOptions(vm.transportationCosts[0].updated_at);
      } else {
        // Create
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRanges);
        vm.paxRangesSelected.push(paxRangeToSelect);

        vm.lastUpdatedAt = false;

        vm.saveButtonLabel = 'SAVE_COSTS';
      }

      setPaxRangesData();
      selectPaxRange(paxRangeToSelect);
    };

    function setItemOptions(updateAt) {
      vm.editMode = true;

      vm.lastUpdatedAt = updateAt;
      vm.saveButtonLabel = 'UPDATE_COSTS';
    }

    // ----- PAX RANGES ----- //
    function selectPaxRange(paxRange) {
      vm.paxRangeSelected = paxRange;
    }

    // Sets the selected Pax Ranges options in the Pax range selector
    function setSelectedPaxRanges() {
      vm.paxRangesSelected = [];

      vm.transportationCosts.forEach(function (transportationCost) {
        vm.paxRanges.forEach(function (paxRange) {
          if (!checkIfPaxRangeExist(paxRange) && transportationCost.pax_range_id === paxRange.id) {
            vm.paxRangesSelected.push(paxRange);
          }
        });
      });

      if (vm.paxRangesSelected.length === 0) {
        // fix
        vm.paxRangesSelected = [vm.paxRanges[0]];
      }
    }

    function checkIfPaxRangeExist(paxRange) {
      for (var i = 0; i < vm.paxRangesSelected.length; i++) {
        if (vm.paxRangesSelected[i] === paxRange) {
          return true;
        }
      }

      return false;
    }

    // Set all costs from the paxRange data, new or saved on the DB
    function setPaxRangesData() {
      vm.paxRangesData = [];

      vm.paxRanges.forEach(function (paxRange) {
        paxRange.transportation_schedules = [];
        // loop for the transportation schedules
        vm.transportation.transportation_schedules.forEach(function (transportationSchedule) {
          var schedule = setTransportationSchedule(transportationSchedule, paxRange);
          if (transportationSchedule.status === 'active') {
            paxRange.transportation_schedules.push(schedule);
          }
        });

        vm.paxRangesData.push(paxRange);
      });
    }

    // Gets the transportation schedule for the selected transportation and pax range
    function setTransportationSchedule(transportationSchedule, paxRange) {
      var transportationCostId;
      var adultCost = '',
        childCost = 0,
        infantCost = 0,
        seniorCost = 0,
        serviceCost = 0;

      // Exist transportation costs
      if (vm.transportationCosts.length) {
        for (var i = 0; i < vm.transportationCosts.length; i++) {
          var transportationCost = vm.transportationCosts[i];

          if (
            transportationCost.pax_range_id === paxRange.id &&
            transportationCost.transportation_schedule_id === transportationSchedule.id
          ) {
            transportationCostId = transportationCost.id;

            adultCost = transportationCost.adult_cost;
            childCost = transportationCost.child_cost;
            infantCost = transportationCost.infant_cost;
            seniorCost = transportationCost.senior_cost;
            serviceCost = transportationCost.service_cost;
            break;
          }
        }
      }

      var schedule = {
        id: transportationSchedule.id,
        departure: transportationSchedule.departure,
        status: transportationSchedule.status,
        adult_cost: adultCost,
        child_cost: childCost,
        infant_cost: infantCost,
        senior_cost: seniorCost,
        service_cost: serviceCost,
        transportationCostId: null,
      };

      if (transportationCostId) {
        schedule.transportationCostId = transportationCostId;
      }

      return schedule;
    }

    function saveTransportationCosts(isFormValid) {
      if (!isFormValid || vm.transportation.transportation_schedules.length === 0) {
        return;
      }

      var transportationCosts = [];

      for (var i = 0; i < vm.paxRangesSelected.length; i++) {
        var paxRangeSelected = vm.paxRangesSelected[i];

        for (var j = 0; j < vm.paxRangesData.length; j++) {
          var paxRangeData = vm.paxRangesData[j];

          if (paxRangeData.id === paxRangeSelected.id) {
            paxRangeData.transportation_schedules.forEach(function (transportationSchedule) {
              var cost = {
                adult_cost: transportationSchedule.adult_cost || 0,
                child_cost: transportationSchedule.child_cost || 0,
                infant_cost: transportationSchedule.infant_cost || 0,
                senior_cost: transportationSchedule.senior_cost || 0,
                service_cost: transportationSchedule.service_cost || 0,

                transportation_schedule_id: transportationSchedule.id,
                pax_range_id: paxRangeSelected.id,
                id: null,
              };

              if (transportationSchedule.transportationCostId) {
                cost.id = transportationSchedule.transportationCostId;
              }

              transportationCosts.push(cost);
            });

            break; // check
          }
        }
      }

      let params = {
        transportation_costs: transportationCosts,
        price_list_id: vm.priceListSelected.id,
        season_id: vm.seasonSelected.id,
        provider_id: vm.provider.id,
        get_associated_providers: null,
      };

      if (vm.getAssociatedProvidersOnSave) {
        params.get_associated_providers = true;
      }

      vm.sendingForm = true;
      TransportationCostService.saveTransportationCosts(
        vm.transportation,
        params,
        vm.editMode
      ).then(function (data) {
        if (data) {
          let obj = vm.getAssociatedProvidersOnSave ? { dataObj: data.associated_providers } : {};

          vm.onTransportationCostsSaved(obj);

          setItemOptions(data.transportation_costs[0].updated_at);

          vm.transportationCosts = data.transportation_costs;
          setPaxRangesData();
        }

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onTransportationCostsCanceled();
    }
  }
})();
